import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const EmailStatus = lazy(() => import("@/pages/EmailStatus"));

export const Route = createFileRoute("/email-status")({
  component: EmailStatus,
});
